// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { GeoFence_abstract } from './../abstract/SagaBase/GeoFence_abstract';
export class GeoFence extends GeoFence_abstract {}
